import { rem } from 'polished';
import { baseFontSize } from '@braindate/ui/lib/token/typography';
import { lap } from '@braindate/ui/lib/token/mediaQuery';

export const SMALL_SIDEBAR_WIDTH = 202;
export const REGULAR_SIDEBAR_WIDTH = 313;

export default {
  inner: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: ({ small }: Object) =>
      small ? SMALL_SIDEBAR_WIDTH : REGULAR_SIDEBAR_WIDTH,
    maxWidth: ({ small }: Object) =>
      small ? SMALL_SIDEBAR_WIDTH : REGULAR_SIDEBAR_WIDTH,
    paddingLeft: 20,
    marginLeft: 20,

    [lap]: {
      paddingLeft: 0,
    },
  },
  createNewTopic: {
    width: '100%',
    margin: [0, 0, 24, 0],
    padding: 0,
    fontSize: rem(20, baseFontSize),
    marginBottom: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 48,
  },
  plusIcon: {
    width: 20,
    marginRight: 13.5,
  },
};
